import React from 'react';
import { Button, Accordion, AccordionItem, Box, Flex } from '@tapresearch/ui/components';
import { Virtuoso } from 'react-virtuoso';
export var OtherAnswersAccordion = function(param) {
    var otherAnswers = param.otherAnswers;
    return /*#__PURE__*/ React.createElement(Flex, {
        align: "flex-start",
        mb: "15px"
    }, /*#__PURE__*/ React.createElement(Accordion, {
        flexGrow: 1
    }, /*#__PURE__*/ React.createElement(AccordionItem, {
        itemTitle: 'See "Other" free-text answers',
        _buttonStyle: {
            as: Button,
            variant: 'subtle',
            fontWeight: 'medium',
            fontSize: 'sm',
            colorScheme: 'blue',
            borderRadius: 'base',
            _hover: {
                bg: 'blue.50'
            }
        }
    }, /*#__PURE__*/ React.createElement(Virtuoso, {
        style: {
            height: '400px'
        },
        totalCount: otherAnswers.length,
        itemContent: function(index) {
            return /*#__PURE__*/ React.createElement(Box, {
                borderBottom: "1px solid",
                borderColor: "gray.200",
                py: 5,
                px: 2
            }, otherAnswers[index]);
        }
    }))));
};
